"use strict";

membershipApp.controller('MembershipController', ['$scope', '$http', '$timeout', '$translate', '$filter', function ($scope, $http, $timeout, $translate, $filter) {
	if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
		$('.logout').on('click', function () {
			$('.logout').toggleClass('active');
		});

		$('body').addClass('mobile')
	}

	var $translateThis = $filter('translate');
	$scope.order = { orderZone: $scope.cardZone, orderCard: $scope.cardType };
	var today = new Date();
	var dd = today.getDate();
	var mm = today.getMonth() + 1;
	var yyyy = today.getFullYear();
	var lastYear = today.getFullYear() - 1;
	var nextYear = today.getFullYear() +	 1;
	var last100Year = today.getFullYear() - 100;
	$scope.newRegistration = false;
	$scope.dashLogin = true;
	$scope.visitsItemsSize = 10;
	$scope.productsItemsSize = 10;
	$scope.choosenMembership = false;
	$scope.showMenu = false;
	$scope.gymIdOwned = gymid;
	$scope.logo = logo;
	if(depositRate){
		$scope.depositRates = depositRate.sort((a,b) => a-b);
	}

	$scope.gymId = gymid;

	var startYear = new Date().getFullYear().toString().substr(-2);
    var currentYear = new Number(startYear);
    currentYear += 20;
    $scope.years = [];

    while (startYear <= currentYear) {
        $scope.years.push(startYear++);
    }

	// Finding TimeZone Offset
	if(timeZone){	
		const timeZones = ["Europe/Andorra","Asia/Dubai","Asia/Kabul","Europe/Tirane","Asia/Yerevan","Antarctica/Casey","Antarctica/Davis","Antarctica/DumontDUrville","Antarctica/Mawson","Antarctica/Palmer","Antarctica/Rothera","Antarctica/Syowa","Antarctica/Troll","Antarctica/Vostok","America/Argentina/Buenos_Aires","America/Argentina/Cordoba","America/Argentina/Salta","America/Argentina/Jujuy","America/Argentina/Tucuman","America/Argentina/Catamarca","America/Argentina/La_Rioja","America/Argentina/San_Juan","America/Argentina/Mendoza","America/Argentina/San_Luis","America/Argentina/Rio_Gallegos","America/Argentina/Ushuaia","Pacific/Pago_Pago","Europe/Vienna","Australia/Lord_Howe","Antarctica/Macquarie","Australia/Hobart","Australia/Melbourne","Australia/Sydney","Australia/Broken_Hill","Australia/Brisbane","Australia/Lindeman","Australia/Adelaide","Australia/Darwin","Australia/Perth","Australia/Eucla","Asia/Baku","America/Barbados","Asia/Dhaka","Europe/Brussels","Europe/Sofia","Atlantic/Bermuda","Asia/Brunei","America/La_Paz","America/Noronha","America/Belem","America/Fortaleza","America/Recife","America/Araguaina","America/Maceio","America/Bahia","America/Sao_Paulo","America/Campo_Grande","America/Cuiaba","America/Santarem","America/Porto_Velho","America/Boa_Vista","America/Manaus","America/Eirunepe","America/Rio_Branco","America/Nassau","Asia/Thimphu","Europe/Minsk","America/Belize","America/St_Johns","America/Halifax","America/Glace_Bay","America/Moncton","America/Goose_Bay","America/Blanc-Sablon","America/Toronto","America/Nipigon","America/Thunder_Bay","America/Iqaluit","America/Pangnirtung","America/Atikokan","America/Winnipeg","America/Rainy_River","America/Resolute","America/Rankin_Inlet","America/Regina","America/Swift_Current","America/Edmonton","America/Cambridge_Bay","America/Yellowknife","America/Inuvik","America/Creston","America/Dawson_Creek","America/Fort_Nelson","America/Whitehorse","America/Dawson","America/Vancouver","Indian/Cocos","Europe/Zurich","Africa/Abidjan","Pacific/Rarotonga","America/Santiago","America/Punta_Arenas","Pacific/Easter","Asia/Shanghai","Asia/Urumqi","America/Bogota","America/Costa_Rica","America/Havana","Atlantic/Cape_Verde","America/Curacao","Indian/Christmas","Asia/Nicosia","Asia/Famagusta","Europe/Prague","Europe/Berlin","Europe/Copenhagen","America/Santo_Domingo","Africa/Algiers","America/Guayaquil","Pacific/Galapagos","Europe/Tallinn","Africa/Cairo","Africa/El_Aaiun","Europe/Madrid","Africa/Ceuta","Atlantic/Canary","Europe/Helsinki","Pacific/Fiji","Atlantic/Stanley","Pacific/Chuuk","Pacific/Pohnpei","Pacific/Kosrae","Atlantic/Faroe","Europe/Paris","Europe/London","Asia/Tbilisi","America/Cayenne","Africa/Accra","Europe/Gibraltar","America/Nuuk","America/Danmarkshavn","America/Scoresbysund","America/Thule","Europe/Athens","Atlantic/South_Georgia","America/Guatemala","Pacific/Guam","Africa/Bissau","America/Guyana","Asia/Hong_Kong","America/Tegucigalpa","America/Port-au-Prince","Europe/Budapest","Asia/Jakarta","Asia/Pontianak","Asia/Makassar","Asia/Jayapura","Europe/Dublin","Asia/Jerusalem","Asia/Kolkata","Indian/Chagos","Asia/Baghdad","Asia/Tehran","Atlantic/Reykjavik","Europe/Rome","America/Jamaica","Asia/Amman","Asia/Tokyo","Africa/Nairobi","Asia/Bishkek","Pacific/Tarawa","Pacific/Enderbury","Pacific/Kiritimati","Asia/Pyongyang","Asia/Seoul","Asia/Almaty","Asia/Qyzylorda","Asia/Qostanay","Asia/Aqtobe","Asia/Aqtau","Asia/Atyrau","Asia/Oral","Asia/Beirut","Asia/Colombo","Africa/Monrovia","Europe/Vilnius","Europe/Luxembourg","Europe/Riga","Africa/Tripoli","Africa/Casablanca","Europe/Monaco","Europe/Chisinau","Pacific/Majuro","Pacific/Kwajalein","Asia/Yangon","Asia/Ulaanbaatar","Asia/Hovd","Asia/Choibalsan","Asia/Macau","America/Martinique","Europe/Malta","Indian/Mauritius","Indian/Maldives","America/Mexico_City","America/Cancun","America/Merida","America/Monterrey","America/Matamoros","America/Mazatlan","America/Chihuahua","America/Ojinaga","America/Hermosillo","America/Tijuana","America/Bahia_Banderas","Asia/Kuala_Lumpur","Asia/Kuching","Africa/Maputo","Africa/Windhoek","Pacific/Noumea","Pacific/Norfolk","Africa/Lagos","America/Managua","Europe/Amsterdam","Europe/Oslo","Asia/Kathmandu","Pacific/Nauru","Pacific/Niue","Pacific/Auckland","Pacific/Chatham","America/Panama","America/Lima","Pacific/Tahiti","Pacific/Marquesas","Pacific/Gambier","Pacific/Port_Moresby","Pacific/Bougainville","Asia/Manila","Asia/Karachi","Europe/Warsaw","America/Miquelon","Pacific/Pitcairn","America/Puerto_Rico","Asia/Gaza","Asia/Hebron","Europe/Lisbon","Atlantic/Madeira","Atlantic/Azores","Pacific/Palau","America/Asuncion","Asia/Qatar","Indian/Reunion","Europe/Bucharest","Europe/Belgrade","Europe/Kaliningrad","Europe/Moscow","Europe/Simferopol","Europe/Kirov","Europe/Volgograd","Europe/Astrakhan","Europe/Saratov","Europe/Ulyanovsk","Europe/Samara","Asia/Yekaterinburg","Asia/Omsk","Asia/Novosibirsk","Asia/Barnaul","Asia/Tomsk","Asia/Novokuznetsk","Asia/Krasnoyarsk","Asia/Irkutsk","Asia/Chita","Asia/Yakutsk","Asia/Khandyga","Asia/Vladivostok","Asia/Ust-Nera","Asia/Magadan","Asia/Sakhalin","Asia/Srednekolymsk","Asia/Kamchatka","Asia/Anadyr","Asia/Riyadh","Pacific/Guadalcanal","Indian/Mahe","Africa/Khartoum","Europe/Stockholm","Asia/Singapore","America/Paramaribo","Africa/Juba","Africa/Sao_Tome","America/El_Salvador","Asia/Damascus","America/Grand_Turk","Africa/Ndjamena","Indian/Kerguelen","Asia/Bangkok","Asia/Dushanbe","Pacific/Fakaofo","Asia/Dili","Asia/Ashgabat","Africa/Tunis","Pacific/Tongatapu","Europe/Istanbul","America/Port_of_Spain","Pacific/Funafuti","Asia/Taipei","Europe/Kiev","Europe/Uzhgorod","Europe/Zaporozhye","Pacific/Wake","America/New_York","America/Detroit","America/Kentucky/Louisville","America/Kentucky/Monticello","America/Indiana/Indianapolis","America/Indiana/Vincennes","America/Indiana/Winamac","America/Indiana/Marengo","America/Indiana/Petersburg","America/Indiana/Vevay","America/Chicago","America/Indiana/Tell_City","America/Indiana/Knox","America/Menominee","America/North_Dakota/Center","America/North_Dakota/New_Salem","America/North_Dakota/Beulah","America/Denver","America/Boise","America/Phoenix","America/Los_Angeles","America/Anchorage","America/Juneau","America/Sitka","America/Metlakatla","America/Yakutat","America/Nome","America/Adak","Pacific/Honolulu","America/Montevideo","Asia/Samarkand","Asia/Tashkent","America/Caracas","Asia/Ho_Chi_Minh","Pacific/Efate","Pacific/Wallis","Pacific/Apia","Africa/Johannesburg","America/Antigua","America/Anguilla","Africa/Luanda","Antarctica/McMurdo","America/Aruba","Europe/Mariehamn","Europe/Sarajevo","Africa/Ouagadougou","Asia/Bahrain","Africa/Bujumbura","Africa/Porto-Novo","America/St_Barthelemy","America/Kralendijk","Africa/Gaborone","Africa/Kinshasa","Africa/Lubumbashi","Africa/Bangui","Africa/Brazzaville","Africa/Douala","Europe/Busingen","Africa/Djibouti","America/Dominica","Africa/Asmara","Africa/Addis_Ababa","Africa/Libreville","America/Grenada","Europe/Guernsey","Africa/Banjul","Africa/Conakry","America/Guadeloupe","Africa/Malabo","Europe/Zagreb","Europe/Isle_of_Man","Europe/Jersey","Asia/Phnom_Penh","Indian/Comoro","America/St_Kitts","Asia/Kuwait","America/Cayman","Asia/Vientiane","America/St_Lucia","Europe/Vaduz","Africa/Maseru","Europe/Podgorica","America/Marigot","Indian/Antananarivo","Europe/Skopje","Africa/Bamako","Pacific/Saipan","Africa/Nouakchott","America/Montserrat","Africa/Blantyre","Africa/Niamey","Asia/Muscat","Africa/Kigali","Atlantic/St_Helena","Europe/Ljubljana","Arctic/Longyearbyen","Europe/Bratislava","Africa/Freetown","Europe/San_Marino","Africa/Dakar","Africa/Mogadishu","America/Lower_Princes","Africa/Mbabane","Africa/Lome","Africa/Dar_es_Salaam","Africa/Kampala","Pacific/Midway","Europe/Vatican","America/St_Vincent","America/Tortola","America/St_Thomas","Asia/Aden","Indian/Mayotte","Africa/Lusaka","Africa/Harare" ]

		let timezoneP = timeZone.split(') ');
		let timezonePi = timezoneP[1].split(',');
		let timeZoneC = timezonePi[0];
		let timeZoneF = timeZones.find(el => el.includes(timeZoneC)); 

		let timeZoneOffsetSplit = timezoneP[0].split('UTC');
		$scope.timeZoneOffset = timeZoneOffsetSplit[1];

		// moment.tz.setDefault(timeZoneF);
	}

	$(window).on('resize load', function(){
		if ( $(window).width() < 768 ){
			$scope.visitsItemsSize = 3;
			$scope.productsItemsSize = 3;			
		}else{
			$scope.visitsItemsSize = 10;
			$scope.productsItemsSize = 10;
		}
		$scope.$apply();
	})

	if(hideDate)
		$scope.hideDate = hideDate;

	$scope.text = 'me@example.com';
	$scope.emailFormat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	$scope.phoneFormat = gym[0].Culture.includes('GB') ? /^[0-9\s]{5,11}$/ : /^[0-9]{5,15}$/;

	if (dd < 10) {
		dd = '0' + dd
	}

	if (mm < 10) {
		mm = '0' + mm
	}

	today = mm + '/' + dd + '/' + yyyy;
	todayOneYearAgo = mm + '/' + dd + '/' + lastYear;
	todayPlusOneYear = mm + '/' + dd + '/' + nextYear;
	todayOneHundredYearAgo = mm + '/' + dd + '/' + last100Year;

	if( $scope.mobileApp ){
		$scope.filterStartDate = new Date(todayOneYearAgo);
		$scope.filterEndDate = new Date(today);
	}

	// $scope.showLogin = function () {
	// 	$scope.dashLogin = true;
	// }
	// $scope.showLogin();

	// $scope.hideLogin = function () {
	// 	$scope.dashLogin = false;
	// }

	if (newRegistration) {
		$scope.newRegistration = true;
	}

	var paysafeinit = false;
	var Model = window.Model;

	console.log(clientModel);
	if (clientModel) {
		$scope.Model = clientModel;
		$scope.Client = $scope.Model.Client;
		$scope.Waivers = $scope.Model.Waivers;
		console.log($scope.Waivers);


		if ($scope.Model.Register) {
			$scope.FormRegister = $scope.Model.Register;
		}

		if($scope.Client && !localStorage.getItem('userModel')){
			localStorage.setItem('userModel', JSON.stringify($scope.Model));
		}
	}

	if (gymdivision ) {
		$scope.GymDivision = gymdivision;
		$scope.Division = gymdivision.GymName;
		$scope.DivisionID = gymdivision.GymID;
		var $translateThis = $filter('translate');
		var title = $translateThis('title');
		document.title = $scope.Division + ' ' + title;
	}


	$scope.dateFeaturedFormat = 'dd/MM/yyyy';
	$scope.dateFeaturedFormatDatepicker = 'dd/mm/yy';
	if (gym) {
		$scope.gym = gym;
		$($scope.gym[0].BODYPart).prependTo('.body-scripts');
		$($scope.gym[0].HEADPart).appendTo(document.head);

		$scope.gymName = $scope.gym.GymName;
		$scope.AdditionInfo;

		if ($scope.AdditionInfo) {
			var prtext = $scope.AdditionInfo.replace(/\n/g, '<br />')
			$(window).on('load', function () {
				$('.section-addtext').html(prtext);
			});
		}

		if ( gym[0].Culture == 'en-US' ) {
			$scope.dateFeaturedFormat = 'MM/dd/yyyy';
			$scope.dateFeaturedFormatDatepicker = 'mm/dd/yy';
		}
		
		
	}

	if (learnedFrom) {
		$scope.learnedFrom = learnedFrom
	}

	$scope.getClientServices = function () {
		var dataObject = {
			Namespace: namespace,
			Email: $scope.Client.Email,
			datestart: today,
			dateend: todayPlusOneYear
		}
		$http({
			method: 'POST',
			url:'/ScheduleV2/GetClientSchedule',
			data: dataObject
		}).success(function (data) {
			if ( data.length == 0 ) {
				$scope.noEvents = true;
			}
			else{
				$scope.noEvents = false;	
			}
		}).error(function () {

		});
	}

	// Cients Portal Filter 
	var from = $("#from");
	var to = $("#to");

	$scope.getItemsFromThePast = function (item) {
		var today = new Date();
		return item.date < today;
	}

	$scope.currentLang = $translate.proposedLanguage() || $translate.use();

	from.datepicker({
		changeMonth: true,
		changeYear: true,
		yearRange: "1920:2040",
		numberOfMonths: 1,
		dateFormat: $scope.dateFeaturedFormatDatepicker,
		onSelect: function (dateText, inst) {
			var origin_date = $(this).val();

			if ($scope.gym[0].Culture != 'en-US') {
				var res = origin_date.split("/");
				var date = res[1] + '/' + res[0] + '/' + res[2];

				$scope.filterStartDate = date;
			}else{
				$scope.filterStartDate = origin_date;
			}
			
			to.datepicker("option", "minDate", origin_date);
		}
	});

	to.datepicker({
		changeMonth: true,
		changeYear: true,
		yearRange: "1920:2040",
		numberOfMonths: 1,
		dateFormat: $scope.dateFeaturedFormatDatepicker,
		// dateFormat: 'mm.dd.yy',
		onSelect: function (dateText, inst) {
			var origin_date = $(this).val();

			if ($scope.gym[0].Culture != 'en-US') {
				var res = origin_date.split("/");
				var date = res[1] + '/' + res[0] + '/' + res[2];
				$scope.filterEndDate = date;
			}else{
				$scope.filterEndDate = origin_date;
			}
			
			from.datepicker("option", "maxDate", origin_date);
		}
	});

	$('.ui-datepicker').addClass('notranslate');

	// Tabs
	$('.tabs .nav-tabs a').click(function (e) {
		e.preventDefault()
		$(this).tab('show')
	});

	$('#rateVisitModal').on('show.bs.modal', function (e) {
		$scope.visitId = parseInt(e.relatedTarget.dataset.id);
		// find visit in visits
		let visit = findElement($scope.visits, "VisitID", $scope.visitId);
		$timeout(function() {
			$scope.ratingVisit = visit;
		})
	})

	function findElement(arr, propName, propValue) {
		for (var i = 0; i < arr.length; i++)
			if (arr[i][propName] == propValue)
				return arr[i];
		// will return undefined if not found; you could return a default instead
	}

	// Rate function
	$scope.rate = function (rate, comment) {
		var dataObject = {
			Rating: rate,
			ClientID: $scope.Client.ClientID,
			Comment: comment,
			Namespace: namespace,
			GymId: $scope.gymId,
			VisitID: $scope.visitId,
		}
		$http({
			method: 'POST',
			url: '/rating/RateVisit',
			data: dataObject
		}).success(function (data) {

			let result = JSON.parse(data.toLowerCase());
			console.log(result);

			if(result){
				$('#rateVisitModal').modal('hide')
			}else{
				
			}
			// $('.popup-wrapper').removeClass('show');
		}).error(function () {
		});
	}

	// Cancel Membership
	$scope.cancelMembershipModal = function(ServiceID, CardID, ClientID){

		cancelRecurringReasons();
		$('#cancelMembershipModal').modal('show');

		$scope.cancelMembershipData = {
			GymID: gymid,
			Namespace: namespace,
			ServiceID: ServiceID,
			CardID: CardID,
			ClientID: ClientID,
			Email: $scope.Client.Email
		}
	}

	$scope.cancelMembership = function(){
		// CancelRecurring(int ServiceID, int CardID, int ClientID, string Email, string Reason, int GymID, string Namespace)
		$scope.cancelMembershipData.Reason = $scope.cancelReasonsSelect == 'other' ? $scope.cancelReasonsText : $scope.cancelReasonsSelect;
		$http({
			method: 'POST',
			url:'/membership/CancelRecurring',
			data: $scope.cancelMembershipData
		}).success(function (data) {
			console.log(data);

			if(data == 'true' || data == true || data == 'True'){
				var translated = $translateThis('Membership Cancled.');
				Swal.fire({
					type: 'success',
					title: translated,
					onAfterClose: (function () {
						$('#cancelMembershipModal').modal('hide');
						window.location.reload(true);
					})
				})
			}else{
				var translated = $translateThis('Cannot cancel recurring!');
				Swal.fire({
					type: 'warning',
					title: translated,
					onAfterClose: (function () {
						$('#cancelMembershipModal').modal('hide');
					})
				})
			}

		}).error(function () {

		});
	}

	function cancelRecurringReasons(){
		// CancelRecurringReasons(string Language, int GymID, string Namespace)

		let dataObject = {
			GymID: gymid,
			Namespace: namespace,
			Language: $scope.currentLang
		}

		dataObject 
		$http({
			method: 'POST',
			url:'/membership/CancelRecurringReasons',
			data: dataObject
		}).success(function (data) {
			console.log(data);
			$scope.cancelReasons = data;
		}).error(function () {

		});
	}

	$scope.dateFilter = function (from, to) {
		var fromT = new Date(from);
		var toT = new Date(to);
		toT.setHours(23, 59, 0, 0);

		var dataObject = {
			ClientID: $scope.Client.ClientID,
			CardID: $scope.Client.CardID,
			Email: $scope.Client.Email,
			DateStart: fromT,
			DateEnd: toT,
			Namespace: namespace,
			GymId: gymid,
		}

		$scope.paging = [];
		$scope.products_paging = [];

		$http({
			method: 'POST',
			url: '/account/GetReport',
			data: dataObject
		}).success(function (data) {
			$scope.visits = data.Visits;
			$scope.memberships = data.PastServices;
			$scope.products = data.Products;
			let dataServices  = data.Services;
			$scope.Services  = data.Services;
			$scope.Deposit = data.Deposit;

			if (dataServices.length > 0) {
				$scope.activeServices = false;

				for (let index = 0; index < dataServices.length; index++) {
					const element = dataServices[index];
					let now = moment();
					let elDateStart = moment(element.DateStart);
					if(elDateStart <= now){
						element.State = 'current';
					}else{
						element.State = 'future';
					}
				}

				$timeout(function() {
					$scope.membershipFilter = {State: 'current'};
					$scope.Services = dataServices;
				})
			} else {
				$scope.activeServices = true;
			}

			$('body').addClass('loaded');
		}).error(function () {
		});
	}

	$(window).on('load', function () {

		if( $('.unauthenticated').length ){
			localStorage.removeItem('userModel');
			console.log('remove USers');
		}else{
			if(localStorage.getItem('userModel')){
				if(redirected && $('.dashboard').length){
					localStorage.setItem('userModel', JSON.stringify($scope.Model));
				}
				let modelStorage = localStorage.getItem('userModel');
				$scope.Model =  JSON.parse(modelStorage);
				if($scope.Client == null)
					$scope.Client =  $scope.Model.Client;
			}

			if($('.dashboard').length){
				$scope.dateFilter(todayOneYearAgo, today);
			}

			if(!$('.onepage-wrapper').length){
				getClientMembership();
			}
		}
		
		if ($('.dashboard').length) {
			$(".page-wrapper").addClass('show-forgetme');
		}
		
		let phoneLang = getLanguage($scope.gym[0].Culture);
		var input = document.querySelector("#Telephone");
		if(input){

			if($scope.gym[0].Culture.includes('GB')){
				$('#Telephone')
				.on('keydown', function (e) {
					if(e.keyCode == 32){
						return false;
					}
				})
				.on('keyup', function (e) {
					if(e.target.value.length == 4){
						e.target.value = e.target.value += ' ';
					}
				});
			}

			$scope.inputPhone = window.intlTelInput(input, {
				autoHideDialCode: false,
				preferredCountries: [phoneLang],
				separateDialCode: true
			});

			input.addEventListener("countrychange", function() {
                let countryinfo = $scope.inputPhone.getSelectedCountryData()
                if(countryinfo.dialCode == '44'){
                    input.value = input.value.split(' ').join('');
                    if(input.value.length > 4){
                        input.value = input.value.substring(0, 4) + " " + input.value.substring(4, 10);
                    }
					
                    $scope.phoneFormat = /^[0-9\s]{5,11}$/;
                    $('#Telephone')
                    .on('keydown', function (e) {
						$('#Telephone').addClass('ng-touched');
                        if(e.keyCode == 32){
                            return false;
                        }
                    })
                    .on('keyup', function (e) {
                        if(e.target.value.length == 4){
                            e.target.value = e.target.value += ' ';
                        }
                    });
                }else{
                    input.value = input.value.split(' ').join('');
                    $scope.phoneFormat = /^[0-9]{5,15}$/;
                    $scope.waiverForm.Telephone.$validate()
                    $('#Telephone')
                    .on('keydown', function (e) {
                        if(e.keyCode == 32){
                            return false;
                        }
                    })
                    .on('keyup', function (e) {
                        if(e.target.value.length == 4){
                            // e.target.value = e.target.value += ' ';
                        }
                    });
                }
            });
		}
	})

	// Get Language from backend settings
	function getLanguage(culture){
		let lang = culture.split('-');
		lang = lang[1].toLowerCase();
		return lang;
	}

	// Popup
	$('.popup-wrapper .close').on('click', function (e) {
		e.preventDefault();
		$('.popup-wrapper').removeClass('show');
	})

	$scope.popupOpen = function (visitId, gymId) {
		$('.popup-wrapper[data-id="rateVisit"]').addClass('show');
		$scope.visitId = visitId;
		$scope.gymId = gymId;
	}

	$('.calendar-filter .field i').on('click', function (e) {
		$(this).parent().find('input').datepicker('show');
	});

	// Get Settings

	if (namespace) {
		$scope.namespace = namespace;
		$scope.getSettings = function () {
			var dataObject = {
			    Namespace: namespace,
			    GymID: $scope.DivisionID
			}
			$http({
				method: 'POST',
				url: '/Membership/GetSettings',
				data: dataObject
			}).success(function (data) {
				$scope.membershipSettings = data;
				window.membershipCurrencyCode = data.CurrencyCode;

				// Rebuild depositRates to force Angular to re-render options
				if ($scope.depositRates) {
					var tempRates = $scope.depositRates;
					$scope.depositRates = [];
					$timeout(function() {
						$scope.depositRates = tempRates;
					});
				}
				$scope.$applyAsync();
			}).error(function () {
				// console.log('error');
			});
		}

		$scope.getSettings();
	}

	// Index forms

	// ForgotPassword
	$scope.accForgotPassword = function () {
		$scope.loading = true;
		var gymid = $('#accGymID').val();
		var namespace = $('#accNamespace').val();
		var email = $('#Email').val();
        email = email.replace(/ /g,'');

		var dataObject = {
			Email: email,
			Namespace: namespace,
			GymID: gymid,
			PortalVersion: 'v2'
		}

		$http({
			method: 'POST',
			url: '/account/forgotpassword/',
			data: dataObject
		}).success(function (data) {
			var data = data;

			if (data == 'Success') {
				var translated = $translateThis('SuccessPass');
				$('.validation-errors').html('<div class="section-valid success"><p>' + translated + '</p></div>');
			} else {
				console.log(data);
				var translated = $translateThis(data);
				$('.validation-errors').html('<div class="section-valid"><p>' + translated + '</p></div>');
			}

			$scope.loading = false;
		}).error(function () {
			// console.log('error');
		});
	}

	if( $('#Password').length && $('#ConfirmPassword').length ){
		$scope.matchingPassword = false;
		$('#Password, #ConfirmPassword').on('keyup', function () {
			if ($('#Password').val() == $('#ConfirmPassword').val()) {
				$('.validation-errors').html('');
				$scope.matchingPassword = true;
			} else {
				var translated = $translateThis('notMaching');
				$('.validation-errors').html('<div class="section-valid"><p>' + translated + '</p></div>');
				$scope.matchingPassword = false;
			}
		});
	}


	if (code) {
		$scope.code = code;
	}

	// ResetPassword
	$scope.resetPassword = function () {
		if ($scope.matchingPassword == true) {
			$scope.loading = true;

			var namespace = $('#accNamespace').val();
			var email = $('#Email').val();
        	email = email.replace(/ /g,'');
			var password = $('#Password').val();
			var confirmPassword = $('#ConfirmPassword').val();
			var currentHref = window.location;
			var href = currentHref.origin + '/Account/indexv2?nameSpace=' + namespace + '&gymId=' + $scope.DivisionID;

			var dataObject = {
				Email: email,
				Namespace: namespace,
				ConfirmPassword: confirmPassword,
				Password: password,
				Code: $scope.code
			}

			$http({
				method: 'POST',
				url: '/account/resetpassword/',
				data: dataObject
			}).success(function (data) {
				var data = data;

				if (data == 'Success') {
					var translated = $translateThis('Success');
					Swal.fire({
						type: 'success',
						title: translated,
						onAfterClose: (function () {
							$scope.loading = false;
							window.location.replace(href);
						})
					})
				} else {
					var translated = $translateThis(data);
					$('body').attr('style', 'height: 100% !important');
					Swal.fire({
						type: 'warning',
						title: translated,
						onAfterClose: (function () {
							$timeout(function() {
								$scope.loading = false;
							})
						})
					})
				}
			}).error(function () {
				// console.log('error');
			});
		}
	}

	$scope.changePassword = function(){
		if ($scope.matchingPassword == true) {
			$scope.loading = true;

			var dataObject = {
				GymID: gymid,
				Namespace: namespace,
				OldPassword: $('#OldPassword').val(),
				NewPassword: $('#Password').val()
			}

			$http({
				method: 'POST',
				url: '/account/changepassword/',
				data: dataObject
			}).success(function (data) {
				var data = data;
				var translated = $translateThis(data);
				// $('.validation-errors').html('<div class="section-valid"><p>' + translated + '</p></div>');
				
				// if (data == 'Success') {
				// 	$('.validation-errors .section-valid').addClass('success');
				// }
				// $scope.loading = false;

				if (data == 'Success') {
					Swal.fire({
						type: 'success',
						title: translated,
						onAfterClose: (function () {
							$timeout(function() {
								$scope.loading = false;
								$('#changePassword').modal('hide')
							})							
						})
					})
				} else {
					Swal.fire({
						type: 'warning',
						title: translated,
						onAfterClose: (function () {
							$timeout(function() {
								$scope.loading = false;
							})
						})
					})
				}

			}).error(function () {
				// console.log('error');
			});
		}
	}

	// Get Gyms
	$scope.getGyms = function () {
		var dataObject = {
			Namespace: namespace
		}
		$http({
			method: 'POST',
			url: '/Membership/GetGyms',
			data: dataObject
		}).success(function (data) {
			$scope.membershipGyms = data;

		}).error(function () {
			// console.log('error');
		});
	}

	$scope.getGyms();

	if (result) {
		$scope.cancelResult = result;
	}

	function setCookie(key, value) {
		var val = value;
		var expires = new Date();
		expires.setTime(expires.getTime() + (1 * 24 * 60 * 60 * 1000));
		document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
		if (val != "true") {
			$('body').addClass('pound-currency');
		} else {
			$('body').removeClass('pound-currency');
		}
	}

	function getCookie(key) {
		var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
		return keyValue ? keyValue[2] : null;
	}

	$scope.redirectLogin = function () {
		var href = window.location;
		var currentHref = href.origin + '/Account/indexv2?nameSpace=' + namespace + '&gymId=' + $scope.DivisionID;

		var date = $('.step .membersip-card.checked .more-info .info-action input').val();
		setCookie('setUrl', href);
		setCookie('setDate', date);
		window.location.replace(currentHref);
	}
	// PrintClientInfoReport(int ClientID, DateTime DateStart, DateTime DateEnd, int GymID, string AppKey)

	// Get getPrint
	$scope.getPrint = function () {
		var dataObject = {
			ClientID: $scope.Client.ClientID,
			DateStart: todayOneHundredYearAgo,
			DateEnd: today,
			GymID: gymid,
			Namespace: namespace
		}
		$http({
			method: 'POST',
			url: '/Account/PrintClientInfoReport',
			data: dataObject
		}).success(function (data) {
			if ( data ){
				var membershipPrint = data;
				window.location.replace(membershipPrint);
			}
		}).error(function () {
			// console.log('error');
		});
	}

	// Get getPrint
	$scope.forgetAboutMe = function () {

		var href = window.location;
		var currentHref = href.origin + '/Account/indexv2?nameSpace=' + namespace + '&gymId=' + $scope.DivisionID;

		var forgetAboutMe1 = 'Forgotten';
		var forgetAboutMe2 = 'Customer';

		if ($scope.currentLang = 'bg') {
			forgetAboutMe1 = 'Забравен';
			forgetAboutMe2 = 'Клиент';
		}

		var dataObject = {
			ForgetMe1: forgetAboutMe1,
			ForgetMe2: forgetAboutMe2,
			GymID: gymid,
			Namespace: namespace
		}
		$http({
			method: 'POST',
			url: '/Account/ForgetMe',
			data: dataObject
		}).success(function (data) {

			$('.popup-wrapper').addClass('responded');

			if (data == 'true') {
				$scope.forgotten = true;

				setTimeout(function () {
					window.location.replace(currentHref);
				}, 1500);
			} else {
				$scope.forgotten = false;
				$('.popup-wrapper').removeClass('responded');
			}

		}).error(function () {
			// console.log('error');
		});
	}

	// 
	// Unban Code Starts Here
	// 

	function unBanMe(){
		$scope.loading = true;
		// ScheduleV2/UnBanClientPaymentValues(int ClientID, string PaymentType, string Namespace, int GymID, string Language)
		var dataObject = {
			GymID: $scope.gymIdOwned,
			Namespace: namespace,
			ClientID: $scope.Client.ClientID,
			PaymentType: $scope.unbanModel.paymentMethod,
			Language: $scope.currentLang
		}
		$http({
			method: 'POST',
			url: '/ScheduleV2/UnBanClientPaymentValues',
			data: dataObject
		}).success(function (data) {

			if(data.Success){
				if(data.StripeValues){
					// stripeConfirmCardUnban(data.StripeValues, data.OrderID)
					$scope.unbanModel.orderId = data.OrderID;
					stripeInitializeMulti(data.StripeValues);
				}else if(data.MyPosValues){
					post_to_url(data.MyPosValues, 'post');
				}
			}else{
				let translated = $translateThis(data.ResponseMsg);
				Swal.fire({
					type: 'warning',
					title: translated,
					onAfterClose: function (a){
						$timeout(() => $scope.loading = false)
					}
				});
			}
			
		}).error(function () {
			// console.log('error');
		});
	}

	$scope.unBanMe = function(){
		if($scope.unbanModel.paymentMethod == '7'){
			stripeConfirmPaymentMulti();
		}else if($scope.unbanModel.paymentMethod == '8'){
			unBanMe();
		}
	}

	function stripeInitializeMulti(data, deposit = false){
		$scope.stripe = Stripe($scope.membershipSettings.StripePublishKey, {
			betas: ['mb_way_pm_beta_1'],
		});
		
		const options = {
			clientSecret: data.ClientSecret,
			appearance: {/*...*/},
		};
		let clientName = $scope.Client.FirstName + ' ' + $scope.Client.LastName;
		

		$scope.stripeElements = $scope.stripe.elements(options);
		
		const paymentElementOptions = { 
			layout: 'accordion',
			fields: {
				billingDetails: {
					address: {
						postalCode: $scope.membershipSettings.HidePostalCode ? 'never' : 'auto'
					}
				}
			},
			defaultValues: {
				billingDetails: {
					name: clientName,
					email: 'never',
                    phone: 'never'
				}
			}
		};
		const paymentElement = $scope.stripeElements.create('payment', paymentElementOptions);
		if(deposit){
			$scope.stripeError = document.getElementById('error-message-deposit');
			paymentElement.mount('#payment-element-deposit');
		}else{
			$scope.stripeError = document.getElementById('error-message-unban');
			paymentElement.mount('#payment-element-unban');
		}
		$scope.loading = false;
	}

	function stripeConfirmPaymentMulti(deposit = false){
		if (!$scope.stripe || !$scope.stripeElements) return;
		$scope.loading = true;

		$scope.stripe.confirmPayment({
			elements: $scope.stripeElements,
			redirect: 'if_required',
		}).then(function(result) {
			var error = result.error;
			var paymentIntent = result.paymentIntent;

			if (error) {
				$timeout(function() {
					$scope.loading = false;
					if ($scope.stripeError) $scope.stripeError.textContent = error.message;
				});
			} else {
				switch (paymentIntent.status) {
				case 'succeeded':
					// $scope.placeOrder(true);
					if(deposit){
						DepositBuyComplete(paymentIntent.id, $scope.depositModel.orderId);
					}else{
						unBanClientComplete(paymentIntent.id, $scope.unbanModel.orderId);
					}
					break;
				case 'requires_payment_method':
					$timeout(function() {
						$scope.loading = false;
						var msg = (paymentIntent.last_payment_error && paymentIntent.last_payment_error.message)
							? paymentIntent.last_payment_error.message
							: 'Payment failed. Please try another payment method.';
						var translatedMsg = $translateThis(msg);
						Swal.fire({ type: 'warning', title: translatedMsg });
					});
					break;
				default:
					$timeout(function() {
						$scope.loading = false;
					});
					break;
				}
			}
		});
	}

	// ScheduleV2/UnBanClientComplete(int ClientID, string PaymentType, string PaymentIntentID, int OrderID, int GymID, string Namespace)

	function unBanClientComplete(intent, orderId){
		var dataObject = {
			GymID: $scope.gymIdOwned,
			Namespace: namespace,
			ClientID: $scope.Client.ClientID,
			PaymentType: $scope.unbanModel.paymentMethod,
			PaymentIntentID: intent,
			OrderID: orderId
		}
		$http({
			method: 'POST',
			url: '/ScheduleV2/UnBanClientComplete',
			data: dataObject
		}).success(function (data) {
			let translated = $translateThis(data.ResponseMsg);
			let status = data.Success ? 'success' : 'warning';
			Swal.fire({
				type: status,
				title: translated,
				onAfterClose: function (a){
					$timeout(() => {
						$scope.loading = false;
						$scope.Client.BanBooking = false;
					})
					
					$('#unBanModal').modal('hide');
				}
			});
		}).error(function () {
			let translated = $translateThis('Error');
			Swal.fire({
				type: 'warning',
				title: translated,
				onAfterClose: function (a){
					$timeout(() => $scope.loading = false)
				}
			});
		});
	}



	$scope.unbanpaymentChange = function(){
		if ($scope.unbanModel.paymentMethod == '7') {
			unBanMe();
		}
	}

	// private/GetUnBanVisitPrice(int GymID, string Namespace)
	function getUnBanVisitPrice(){
		var dataObject = {
			GymID: $scope.gymIdOwned,
			Namespace: namespace
		}
		$http({
			method: 'POST',
			url: '/private/GetUnBanVisitPrice',
			data: dataObject
		}).success(function (data) {
			$scope.unBanPrice = data;

			if ($('.dashboard').length) {
				if($scope.Client.BanBooking){
	
					let translated = $translateThis('Your access to the booking system has been suspended due to non-compliance with the rules of the sports center. Please contact reception.');
					let translatedConfirrm = $translateThis('Pay');

					if($scope.Client.BanBooking && $scope.unBanPrice > 0){
						Swal.fire({
							type: 'warning',
							title: translated,
							showCloseButton: true,
							confirmButtonText: translatedConfirrm,
						}).then((result) => {
							/* Read more about isConfirmed, isDenied below */
							if (result.value) {
								$('#unBanModal').modal('show')
							}
						})
					}else{
						Swal.fire({
							type: 'warning',
							title: translated
						});
					}
				}
			}
		}).error(function () {
			// console.log('error');
		});
	}

	$scope.unbanModel = {paymentMethod: null};
	$('#unBanModal').on('shown.bs.modal', function () {
		if($('#selectPaymentMethodUnban option.ng-scope').length == 1){
			$timeout(() => $scope.unbanModel.paymentMethod = $('#selectPaymentMethodUnban option.ng-scope').val())
			$scope.unbanpaymentChange();
		}
	})

	// 
	// Unban Code Ends Here
	// 


	// 
	// Deposit Code Starts Here
	// 


	function getClientMembership(){

		let dataObject = {
			Namespace: namespace,
			ClientID: $scope.Client.ClientID,
		}
		
		$http({
			method: 'POST',
			url: '/Membership/GetClientGroupMembers',
			data: dataObject
		}).success(function (data) {
			console.log(data);
			$scope.clientGroupMembers = data;
			if(data.length == 1 && data[0].ClientID == $scope.Client.ClientID){
				$scope.clientGroupMembers = [];
			}
		}).error(function (error) {
			console.log(error);
		});
	}

	// Нов метод за зареждане на депозит, връща полетата за майпос или страйп
	// GiftCard/BuyDepositPaymentValues(int ClientID, string PaymentType, decimal Price,string Language, int GymID, string NameSpace)

	function buyDepositPaymentValues(){
		$scope.loading = true;
		var dataObject = {
			GymID: $scope.gymIdOwned,
			Namespace: namespace,
			ClientID: $scope.Client.ClientID,
			PaymentType: $scope.depositModel.paymentMethod,
			Language: $scope.currentLang,
			Price: $scope.depositModel.rate
		}

		if(typeof $scope.clientGroupMemberSel === 'string'){
			$scope.clientGroupMember = JSON.parse($scope.clientGroupMemberSel);
			dataObject.ClientID = $scope.clientGroupMember.ClientID;
		}

		$http({
			method: 'POST',
			url: '/GiftCard/BuyDepositPaymentValues',
			data: dataObject
		}).success(function (data) {
			if( $scope.depositModel.paymentMethod == '15' ){
				if(data.IsSuccess){
					window.location.href = data.PaymentLinkUrl;
				}else{
					Swal.fire({
						type: 'warning',
						title: data.ErrorMessage,
						onAfterClose: (function () {
							$timeout(function() {
								$scope.loading = false;
							});
						})
					});
				}
			}else if(data.Success){
				if(data.StripeValues){
					// stripeConfirmCardDeposit(data.StripeValues, data.OrderID)
					$scope.depositModel.orderId = data.OrderID;
					stripeInitializeMulti(data.StripeValues, true);
				}else if(data.MyPosValues){
					post_to_url(data.MyPosValues, 'post');
				}else if(data.CPayValues){
					post_to_url(data.CPayValues, 'post', data.CPayValues.PaymentUrl);
				}
			}else{
				let translated = $translateThis(data.ResponseMsg);
				Swal.fire({
					type: 'warning',
					title: translated,
					onAfterClose: function (a){
						$timeout(() => $scope.loading = false)
					}
				});
			}
			
		}).error(function () {
			// console.log('error');
		});
	}
	$scope.buyDeposit = function(){
		if($scope.depositModel.paymentMethod == '9'){
			stripeConfirmPaymentMulti(true);
		}else{
			buyDepositPaymentValues();
		}
	}

	function post_to_url(params, method, url) {
		let path = $scope.membershipSettings.MyPosTestingMode ? 'https://www.mypos.com/vmp/checkout-test' : 'https://www.mypos.com/vmp/checkout';
		if(url){
            path = url;
        }
		method = method || "post";
	
		var form = document.createElement("form");
		form.setAttribute("method", method);
		form.setAttribute("action", path);
		
	
		for(var key in params) {
			if(params.hasOwnProperty(key)) {
				var hiddenField = document.createElement("input");
				hiddenField.setAttribute("type", "hidden");
				hiddenField.setAttribute("name", key);
				hiddenField.setAttribute("value", params[key]);
	
				form.appendChild(hiddenField);
			 }
		}
	
		document.body.appendChild(form);
		form.submit();
	}

	// След успешно плащане със страйп се вика
	// GiftCard/BuyDepositComplete(string PaymentType, string PaymentIntentID, int OrderID, int GymID, string NameSpace)
	function DepositBuyComplete(intent, orderId){
		var dataObject = {
			GymID: $scope.gymIdOwned,
			Namespace: namespace,
			ClientID: $scope.Client.ClientID,
			PaymentType: $scope.depositModel.paymentMethod,
			PaymentIntentID: intent,
			OrderID: orderId
		}

		if(typeof $scope.clientGroupMemberSel === 'string'){
			$scope.clientGroupMember = JSON.parse($scope.clientGroupMemberSel);
			dataObject.ClientID = $scope.clientGroupMember.ClientID;
		}
		$http({
			method: 'POST',
			url: '/GiftCard/BuyDepositComplete',
			data: dataObject
		}).success(function (data) {
			let status = data == 'OK' ? 'success' : 'warning';
			let label = data == 'OK' ? 'success purchase' : 'buyError';
			let translated = $translateThis(label);
			Swal.fire({
				type: status,
				title: translated,
				onAfterClose: function (a){
					$timeout(() => {
						$scope.loading = false;
					})
					
					$('#depositModal').modal('hide');
					location.reload();
				}
			});
		}).error(function () {
			let translated = $translateThis('Error');
			Swal.fire({
				type: 'warning',
				title: translated,
				onAfterClose: function (a){
					$timeout(() => $scope.loading = false)
				}
			});
		});
	}

	$scope.depositPaymentChange = function(){
		if ($scope.depositModel.paymentMethod == '9') {

			buyDepositPaymentValues();
		}
	}
	// 
	// Deposit Code Ends Here
	// 


	$scope.downloadWaiver = function(waiver){
		// (string Container, string FileName, string Namespace)
		
		var dataObject = {
			FileName: waiver.FileName,
			Namespace: namespace,
			Container: waiver.Container,
		}

		$http({
			method: 'POST',
			url: '/Waiver/DownloadWaiver',
			data: dataObject
		}).success(function (data) {
			console.log(data);

			if( data == 'Error'){
				let translated = $translateThis('buyError');
				Swal.fire({
					type: 'warning',
					title: translated
				});
			}else{
				window.open(data, "_blank");
			}
		}).error(function () {
			let translated = $translateThis('buyError');
			Swal.fire({
				type: 'warning',
				title: translated
			});
		});
	}

	if(qrCode){
		// var qrcode = new QRCode("qrcode");
		QRCode.toCanvas(document.getElementById('qrcode'), qrCode, {width: 124, scale: 1, margin: 0}, function (error) {
			if (error) console.error(error)
			console.log('success!');
		})

		$scope.qrCode = qrCode;
	}


	if ( gymServices && $('#barcode').length ){
		$scope.gymServices = gymServices;

		if ( $scope.gymServices.length > 0 ) {
			$scope.gymServices = $.grep($scope.gymServices, function(e){ 
			     return e.Name != 'Deposit'; 
			});
			
			$timeout(() => {
				$scope.mySubscription = $scope.gymServices[0];

				if ( $scope.mySubscription.Code ) {
					JsBarcode("#barcode", $scope.mySubscription.Code, {
						background: "transparent",
						width: 1
					});
				}
			})
		}

		$scope.changeServiceModel = function(){
			
			var serviceItem = $scope.mySubscriptionSelect;

			var result = $.grep($scope.gymServices, function (e) { return e.ServiceID == serviceItem; });

			if ( result.length > 0 ) {
				$scope.mySubscription = result[0];
				if ( $scope.mySubscription.Code ) {
					JsBarcode("#barcode", $scope.mySubscription.Code, {
						background: "transparent",
						width: 1
					});
				}else{
					JsBarcode("#barcode", 'Sorry, no code', {
						background: "transparent",
						width: 1
					});
				}
			}
		}
	}

	// Response Message For GroupSchedulePurchase 
	if(response){
		var joinEventResponses = new Array(
			'joinEventResponse1',    // 0 "You have successfully signed up for the event"
			'joinEventResponse2',    // 1 "We are sorry to inform you but the event is full of capacity."
			'joinEventResponse3',    // 2 "You already have a reservation for this event. Please sign up for another hour."
			'joinEventResponse4',    // 3 "We're sorry, but our system has made a mistake, the event does not exist."
			'joinEventResponse5',    // 4 "You don't have an active membership or your membership doesn't support this event."
			'joinEventResponse6',    // 5 "To book a class you must have a deposit on your profile!"
			'joinEventResponse7',    // 6 "You need customer profile in order to book!"
			'joinEventResponseEmpty',// 7
			'joinEventResponseEmpty',// 8
			'joinEventResponse8',    // 9 "Maximum number of allowed bookings {{value}} per day has been reached. You can cancel other bookings through your customer portal profile."
			'joinEventResponse9',    // 10 "Your access to the booking system has been suspended due to non-compliance with the rules of the sports center. Please contact reception."
			'joinEventResponse10'    // 11 "Max weekly visits in class reached"
	);
		$scope.response = $translateThis(joinEventResponses[response]);
	}

	$scope.showPopup = function (sel, id) {
		var selected = sel;
		var id = id;
		$('.popup-wrapper[data-id="' + sel + '"]').addClass('show');
		if (id) {
			$('.popup-wrapper[data-id="' + sel + '"] .btn.agree').attr('data-id', id);
		}
	}

	$scope.closePopup = function (sel) {
		$('.popup-wrapper[data-id="' + sel + '"]').removeClass('show').find('.btn.agree').attr('data-id', '');
	}

	$(window).on('load', function () {
		var lastUrl = getCookie('setUrl');

		if ($('.dashboard').length && lastUrl != null && lastUrl != '') {
			var relocated = false;

			if (!relocated) {
				relocated = true;
				setCookie('setUrl', '');
				window.location.replace(lastUrl);
			}
		}

	})

	$(window).on('load', function(){
		if(!$('.onepage-wrapper').length && !$('.unauthenticated').length){
			getUnBanVisitPrice();
		}
		
		if( $('#Password').length && $('#ConfirmPassword').length ){
			var translated = $translateThis('notMaching');
			$scope.ConfirmPasswordHidden = false;
			$('#Password, #ConfirmPassword').on('keyup', function () {
				if ($('#Password').val() == $('#ConfirmPassword').val()) {
					$('.validation-errors').html('');
					$timeout(function() {
						$scope.ConfirmPasswordHidden = true;
					})
				} else {
					$timeout(function() {
						$scope.ConfirmPasswordHidden = false;
					})
					$('.validation-errors').html('<div class="section-valid"><p>' + translated + '</p></div>');
				}
			});
		}
	})
}]);